export const MODULE = "create-invoice-attachments";
